import { Component } from '@angular/core';
import { UploadFilesComponent } from "./upload-files/upload-files.component";
import {ApiService} from "../../services/api.service";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    UploadFilesComponent,
    FormsModule
  ],
})
export class FooterComponent {
  constructor(private apiService: ApiService) {
  }
  files: File[] = [];

  submitted: boolean = false;

  onInput(textarea: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  formData = {
    name: '',
    email: '',
    message: '',
  }

  clearForm() {
    this.formData = {
      name: '',
      email: '',
      message: '',
    }
  }



  getFiles(file: File[]): void {
    this.files = [...this.files, ...file]; // Обновляем массив файлов
  }

  submitForm() {
    if (!this.submitted) {
      this.apiService.submit(this.formData.name, this.formData.email, this.formData.message, this.files[0]).subscribe((data) => {
        this.clearForm();
        this.submitted = true;
      });
    }
  }
}
